<div #surveyContainer class="survey-content">
    <app-loading-spinner [show-spinner]="isLoading" [loading-text]="loadingText"></app-loading-spinner>
</div>
<app-recaptcha></app-recaptcha>